import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';
import * as uiActions from 'modules/ui';

import Contact from 'components/Contact';

class ContactContainer extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  componentDidMount() {
    const { UIActions } = this.props;
    UIActions.hiddenPalette();
  }

  componentWillUnmount() {
    const { UIActions } = this.props;
    UIActions.showPalette();
  }

  render() {
    const { color } = this.props;

    return (
      <div>
        <Helmet>
          <title>CONTACT - BABY DEEDEE</title>
        </Helmet>
        <Contact color={color}/>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    color: state.ui.get('color'),
  }),
  (dispatch) => ({
    UIActions: bindActionCreators(uiActions, dispatch)
  })
)(ContactContainer);



// WEBPACK FOOTER //
// ./src/containers/ContactContainer.js